module.exports = __webpack_public_path__ + "img/s17.03ed234.png";